import React, { useState } from "react";
import cn from "classnames";
import styles from "./Login.module.sass";
import Item from "../Item";
import TextInput from "../../../components/TextInput";
import { updateUserPassword } from "../../../services/account.service";
import { showSuccess, showError } from "../../../services/toast.service";

const Login = ({ className, userData, loading }) => {
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [updating, setUpdating] = useState(false);
  const [showGeneratedPassword, setShowGeneratedPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswordData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const generateRandomPassword = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()-_+=';
    let result = '';
    const length = 12; // Adjust desired length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };

  const handleGeneratePassword = () => {
    const generated = generateRandomPassword();
    setPasswordData(prev => ({
      ...prev,
      newPassword: generated,
      confirmPassword: generated
    }));
    setShowGeneratedPassword(true);
    showSuccess('Nouveau mot de passe généré !');
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();

    if (!passwordData.oldPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
      showError('Tous les champs sont obligatoires');
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      showError('Les nouveaux mots de passe ne correspondent pas');
      return;
    }

    if (passwordData.oldPassword === passwordData.newPassword) {
      showError("Le nouveau mot de passe doit être différent de l'ancien");
      return;
    }

    setUpdating(true);

    try {
      await updateUserPassword(
        passwordData.oldPassword,
        passwordData.newPassword,
        passwordData.confirmPassword
      );

      setPasswordData({
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
      showSuccess('Mot de passe mis à jour avec succès');
      setShowGeneratedPassword(false);

    } catch (error) {
      console.error('Erreur lors de la mise à jour du mot de passe:', error);
      showError(error.message || 'Une erreur est survenue lors de la mise à jour du mot de passe');
    } finally {
      setUpdating(false);
    }
  };

  return (
    <Item
      className={cn(styles.card, className)}
      title="Mot de passe"
      classTitle="title-purple"
    >
      {loading ? (
        <div className={styles.loading}>Chargement...</div>
      ) : (
        <form className={styles.fieldset} onSubmit={handleUpdatePassword}>
          <TextInput
            className={styles.field}
            label="Ancien mot de passe"
            name="oldPassword"
            type="password"
            value={passwordData.oldPassword}
            onChange={handleChange}
            tooltip="Entrez votre mot de passe actuel"
            required
          />
          <div className={styles.row}>
            <TextInput
              className={styles.field}
              label="Nouveau mot de passe"
              name="newPassword"
              type={showGeneratedPassword ? "text" : "password"}
              value={passwordData.newPassword}
              onChange={handleChange}
              tooltip="Minimum 8 caractères"
              required
            />
            <TextInput
              className={styles.field}
              label="Confirmer le mot de passe"
              name="confirmPassword"
              type={showGeneratedPassword ? "text" : "password"}
              value={passwordData.confirmPassword}
              onChange={handleChange}
              tooltip="Doit être identique au nouveau mot de passe"
              required
            />
          </div>

          {/* Apply the new buttonGroup class */}
          <div className={styles.buttonGroup}>
            <button
              type="button"
              className={cn("button-stroke", styles.button)}
              onClick={handleGeneratePassword}
            >
              Générer mot de passe
            </button>
            {passwordData.newPassword && (
              <button
                type="button"
                className={cn("button-stroke", styles.button)}
                onClick={() => setShowGeneratedPassword(prev => !prev)}
              >
                {showGeneratedPassword ? "Masquer" : "Afficher"}
              </button>
            )}
          </div>

          <button
            className={cn("button-stroke", styles.button)}
            type="submit"
            disabled={updating}
          >
            {updating ? "Mise à jour..." : "Mettre à jour le mot de passe"}
          </button>
        </form>
      )}
    </Item>
  );
};

export default Login;